import { useEffect, useMemo, useState } from "react"
import { Table, Section, Column, FieldType, FieldValue, Link } from "../../../../../features/ui"
import { CreditPayment } from "../../../../administration"
import { useDescribeHooks } from "../../../../../features/data-types"
import { TableName } from "../../../../../tables"
import { useNavigate } from "react-router-dom"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"

export type Props = {
    operationId: string
    creditPayments: CreditPayment[]
}

export const OperationCreditPaymentsTable = (props: Props) => {
    const { operationId, creditPayments } = props
    const MOBILE_BREAKPOINT = 1200

    const { describe } = useDescribeHooks()
    const { getRoutePath } = useRoutesHooks()
    const navigate = useNavigate()
    const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth)

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth)
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    const goToCreditPayment = (id?: string) => () => {
        navigate(getRoutePath(RoutePath.CREDIT_PAYMENTS, id))
    }

    const columns: Column[] = [
        {
            name: 'id',
            type: FieldType.TEXT,
            label: 'Cobro',
            render: (value?: FieldValue) => {
                const creditPayment = creditPayments.find(creditPayment => creditPayment.id === value)!
                const label = describe(TableName.CREDIT_PAYMENTS, creditPayment)
                return <Link
                    text={label}
                    icon="cash-stack"
                    kind="primary"
                    onClick={goToCreditPayment(value! as string)}
                />
            }
        },
        {
            name: 'amount',
            type: FieldType.PRICE,
            label: 'Monto Cancelado'
        }
    ]

    const rows = useMemo(() => creditPayments.map(creditPayment => {
        const operationItem = creditPayment.operationItems.find(operationItem => operationItem.operationId === operationId)!
        return {
            id: creditPayment.id,
            amount: operationItem.amount
        }
    }), [creditPayments])

    return (
        <Section
            id='operationCreditPayments'
            space={windowWidth < MOBILE_BREAKPOINT ? 12 : 8}
        >
            <Table
                columns={columns}
                rows={rows}
                rowId="id"
                readOnly
            />
        </Section>
    )
}
